import { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

const Accordion = () => {
  const [openSection, setOpenSection] = useState(null);

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  return (
    <div className="mt-6">
      {/* Product Information */}
      <div className="border-b border-gray-300">
        <div
          onClick={() => toggleSection('productInfo')}
          className="flex justify-between items-center cursor-pointer py-4"
        >
          <span className="text-lg font-medium text-[#24316a]">Product Information</span>
          {openSection === 'productInfo' ?  <FaChevronDown className='text-[#24316a]' /> : <FaChevronUp className='text-[#24316a]' />}
        </div>
        {openSection === 'productInfo' && (
          <div className="text-[#24316a] p-4">
            <p>Details about the product go here...</p>
          </div>
        )}
      </div>

      {/* Specifications */}
      <div className="border-b border-gray-300">
        <div
          onClick={() => toggleSection('specifications')}
          className="flex justify-between items-center cursor-pointer py-4"
        >
          <span className="text-lg font-medium text-[#24316a]">Specifications</span>
          {openSection === 'specifications' ?  <FaChevronDown className='text-[#24316a]' /> : <FaChevronUp className='text-[#24316a]' />}
        </div>
        {openSection === 'specifications' && (
          <div className="text-[#24316a] p-4">
            <p>Specifications content goes here...</p>
          </div>
        )}
      </div>

      {/* Measure and Install */}
      <div className="border-b border-gray-300">
        <div
          onClick={() => toggleSection('measureInstall')}
          className="flex justify-between items-center cursor-pointer py-4"
        >
          <span className="text-lg font-medium text-[#24316a]">Measure and Install</span>
          {openSection === 'measureInstall' ? <FaChevronDown className='text-[#24316a]' /> : <FaChevronUp className='text-[#24316a]' />}
        </div>
        {openSection === 'measureInstall' && (
          <div className="text-[#24316a] p-4">
            <p>Measure and install content goes here...</p>
          </div>
        )}
      </div>

      {/* Shipping & Production */}
      <div className="border-b border-gray-300">
        <div
          onClick={() => toggleSection('shipping')}
          className="flex justify-between items-center cursor-pointer py-4"
        >
          <span className="text-lg font-medium text-[#24316a]">Shipping & Production</span>
          {openSection === 'shipping' ?  <FaChevronDown className='text-[#24316a]' /> : <FaChevronUp className='text-[#24316a]' />}
        </div>
        {openSection === 'shipping' && (
          <div className="text-[#24316a] p-4">
            <p>Shipping and production content goes here...</p>
          </div>
        )}
      </div>

      {/* Reviews */}
      <div className="border-b border-gray-300">
        <div
          onClick={() => toggleSection('reviews')}
          className="flex justify-between items-center cursor-pointer py-4"
        >
          <span className="text-lg font-medium text-[#24316a]">Reviews</span>
          {openSection === 'reviews' ?  <FaChevronDown className='text-[#24316a]' /> : <FaChevronUp className='text-[#24316a]' />}
        </div>
        {openSection === 'reviews' && (
          <div className="text-[#24316a] p-4">
            <p>Reviews content goes here...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Accordion;
